<style lang="scss">

</style>

<template>
  <!-- eslint-disable -->
  <div class="prisoner-locations-page mb-4">

    <section class="d-flex full-width justify-content-end">
      <b-button @click="$bvModal.show('modal-add-location')" class="btn-success">Add Location</b-button>
    </section>

    <section class="my-2">
      <h4>Filters</h4>

      <div class="row">
        <section class="col-3">
          <label>Location</label>
          <b-form-input
            cy="prisoner-location-input"
            @keyup.enter="searchLocations()"
            v-model="filters.location"
            class="mb-1" :placeholder="'Enter ' + $options.filters.term('prisoner') + ' location'"
          />
        </section>

        <section class="col-3">
          <label>Sort</label>
          <b-form-select @change="searchLocations()" v-model="filters.sort" class="mb-1">
            <b-form-select-option value="updated_at">Updated (Oldest First)</b-form-select-option>
            <b-form-select-option value="-updated_at">Updated (Newest First)</b-form-select-option>
            <b-form-select-option value="location">Location (A-Z)</b-form-select-option>
            <b-form-select-option value="-location">Location (Z-A)</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-3 align-items-center d-flex" style="margin-top: 5px">
          <b-button @click="clearFilters()">Clear filters</b-button>
          <b-button class="btn-success ml-1" @click="searchLocations()">Search</b-button>
        </section>
      </div>
    </section>

    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          hover
          :items="locations"
          :fields="headers"
          :current-page="currentPage"
          :per-page="null"
        >
          <template #cell(updated_at)="data">
            {{data.item.updated_at | formatDateTime}}
          </template>
          <template #cell(created_at)="data">
            {{data.item.created_at | formatDateTime}}
          </template>
          <template #cell(actions)="data">
            <b-dropdown class="m-0"  variant="link" right toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="fas fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item-button class="full-nested-btn"
                                      @click="showLocationModal(data.item, 'modal-update-location')">
                Update
              </b-dropdown-item-button>
              <b-dropdown-item-button class="full-nested-btn"
                                      @click="showLocationModal(data.item, 'modal-delete-location')">
                Delete
              </b-dropdown-item-button>
            </b-dropdown>
          </template>
        </b-table>
        <b-row class="p-1">
          <b-col md="6" class="m-1" v-if="totalRows > filters.limit">
            <b-pagination @change="getLocations()" :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No records</p>
        </b-row>
      </section>
    </b-card>

    <b-modal id="modal-add-location" title="Add new location" hide-footer>
      <add-location @refresh="getLocations()" @close="closeModals()"></add-location>
    </b-modal>

    <b-modal id="modal-update-location" title="Update location" hide-footer>
      <update-location v-if="selectedLocation" :existing-location="selectedLocation" @refresh="getLocations()" @close="closeModals()"></update-location>
    </b-modal>

    <b-modal id="modal-delete-location" title="Delete location" hide-footer>
      <delete-modal v-if="selectedLocation" @close="closeModals()" @delete="deleteLocation(selectedLocation)"
                    :subtitle="selectedLocation.location"
                    title="Are you sure you wish to delete location"></delete-modal>
    </b-modal>
  </div>
  <!-- eslint-enable -->
</template>

<script>
  import LocationService from '@/services/LocationService';
  import AddLocation from '@/views/prisonerLocations/sections/AddLocation.vue';
  import UpdateLocation from '@/views/prisonerLocations/sections/UpdateLocation.vue';
  import DeleteModal from '../../components/modals/DeleteModal.vue';
  import HelperService from '../../services/HelperService';

  export default {
    name: 'LocationSearch',
    components: {
      DeleteModal,
      AddLocation,
      UpdateLocation,
    },
    data() {
      return {
        helperService: new HelperService(),
        loading: true,
        selectedLocation: null,
        headers: [
          { label: `${this.$options.filters.term('prisoner')} Location`, key: 'location' },
          { label: 'Created', key: 'created_at' },
          { label: 'Updated', key: 'updated_at' },
          { label: '', key: 'actions' },
        ],
        locations: [],
        currentPage: 1,
        totalRows: 10,
        filters: {
          location: '',
          skip: 1,
          sort: '-updated_at',
        },
      };
    },
    computed: {},
    watch: {
      currentPage() {
        this.getLocations();
      },
      $route() {
        this.setUp();
      },
    },
    mounted() {
      this.setUp();
    },
    methods: {
      setUp() {
        this.getLocations();
      },
      searchLocations() {
        this.currentPage = 1;

        this.getLocations();
      },
      closeModals() {
        this.$bvModal.hide('modal-add-location');
        this.$bvModal.hide('modal-update-location');
        this.$bvModal.hide('modal-delete-location');
      },
      getLocations() {
        this.filters.skip = (this.currentPage - 1) * this.filters.limit;
        this.closeModals();

        LocationService.getAllLocations(this.filters).then(res => {
          this.loading = false;
          this.locations = res.data.data;
          this.totalRows = res.data.count;
        }).catch(err => {
          console.log('Error getting locations ', err);
          this.$toast.error('Could not get locations, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      clearFilters() {
        this.filters = {
          prisonNumber: '',
          skip: 1,
        };

        this.searchLocations();
      },
      setSelectedLocation(location) {
        this.selectedLocation = location;
      },
      showLocationModal(location, modalName) {
        this.setSelectedLocation(location);
        this.$bvModal.show(modalName);
      },
      deleteLocation(location) {
        // eslint-disable-next-line no-underscore-dangle
        LocationService.deleteLocation(location._id).then(() => {
          this.$toast.success(`Deleted location ${location.location} Successfully`, {
            toastClassName: ['toast-std', 'success-toast'],
          });

          this.getLocations();
        }).catch(err => {
          console.log('error deleting location', err);
          this.$toast.error('Could not delete location, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
    },
  };
</script>
